module.exports = __webpack_public_path__ + "static/media/laborest-512.11c7c427.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/laborest-512.png
// module id = 774
// module chunks = 0